export default "__VITE_ASSET__3b810c8f__"